function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.13 17C8.96 17 8 16.6 7.2 15.8 6.4 15 6 14.02 6 12.87V5c0-.83.3-1.53.88-2.12C7.47 2.3 8.18 2 9 2c.82 0 1.53.3 2.12.88.59.59.88 1.3.88 2.12v7.13c0 .52-.18.96-.54 1.33-.37.36-.81.54-1.34.54-.52 0-.96-.18-1.33-.54-.36-.37-.54-.81-.54-1.34V5h1.13v7.13a.72.72 0 00.75.75c.2 0 .39-.08.53-.22a.72.72 0 00.21-.54V5c0-.53-.18-.97-.54-1.33-.36-.36-.8-.54-1.33-.54s-.97.18-1.33.54c-.36.36-.54.8-.54 1.33v7.88c0 .82.29 1.53.88 2.11.58.6 1.29.88 2.12.88.82 0 1.53-.29 2.11-.88.6-.58.88-1.29.88-2.12V5h1.13v7.88c0 1.14-.4 2.12-1.2 2.92-.8.8-1.78 1.2-2.93 1.2z"
});

function SvgClip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.20a92e21.svg";
export { ForwardRef as ReactComponent };